module.exports = __webpack_public_path__ + "media/images/countryrect/ai-c898ca4c7a96be2868c48e3b156b2d62.svg";